import React from 'react';
import axios from "axios";

import DialogOk from 'Components/Dialog/DialogOk';
import DialogYesNo from 'Components/Dialog/DialogYesNo';
import HintToMembers from 'Components/App/HintToMembers';
import Login from 'Components/Member/Login';
import Modal from 'Components/Core/Modal';
import NavigationTop from 'Components/App/NavigationTop';
import NavigationLeft from 'Components/App/NavigationLeft';
import MemberList from 'Components/Member/MemberList';
import Topics from 'Components/Forum/Topics';
import Foren from 'Components/Forum/Foren';
import Pages from 'Components/PageStore/Pages';
import Sections from 'Components/PageStore/Sections';
import Smilies from 'Components/Forum/Smilies';
import Forum from 'Components/Forum/Forum';
import Settings from 'Components/Member/Settings';
import PhpInfo from 'Components/Admin/PhpInfo';
import PushSubscriptions from 'Components/Admin/PushSubscriptions';
import SystemInfo from 'Components/App/SystemInfo';

export default function Content(props) {

	const x = props.x;
	const io = window.io;

	const conRef = React.useRef(null);
	const webAppRenderd = React.useRef(false);

	const [forumUnread, setForumUnread] = React.useState(0);
	const renderCount = React.useRef(1);

	const [dialog, setDialog] = React.useState([]);
	const [hint, setHint] = React.useState([]);
	const [module, setModule] = React.useState([]);
	const [navigation, setNavigation] = React.useState([]);

	let connection = conRef.current;

	React.useEffect(() => {
		x.was.addHint = addHint;
		x.was.addModule = addModule;
		x.was.addNavigation = addNavigation;
		x.was.getMemberList = getMemberList;
		x.was.removeDialog = removeDialog;
		x.was.removeHint = removeHint;
		x.was.removeModule = removeModule;
		if (renderCount.current === 1) {
			x.was.send = socketSend;
			socketConnect();
		}
		renderCount.current++;
		if (props.webAppReady) {
			if (!webAppRenderd.current) {
				if (props.login === true) {
					webAppRenderd.current = true;
					// addModule(<Login id="login" x={x} formId="login" title="Login" />)
				}
				else {
					x.was.webapp = 1;
					init();
					makeContent();
					webAppRenderd.current = true;
				}
			}
		}
	});

	async function getMemberList(orderField) {
		const getData = async (orderField) => {
			const url = 'Backend/webapp.php?module=Member&task=MemberList&active=1' + ((orderField === '') ? '' : '&order-field=' + orderField);
			const result = await axios.get(url);
			return result;
		}
		const result = await getData(orderField)
		if (result.data['returncode'] === 1) {
			setForumUnread(result.data.content[0].postingsunread);			
		}
		return result;
	}


	function socketConnect() {

		connection = io(document.location.href, { path: "/Websocket/" });
		x.was.webSocket = connection;
		
		connection.on('hint', (args) => {
			args = JSON.parse(args);
			x.wah.addHint(args.hint);
			return true;
		});
		
		connection.on('new-posting', (args) => {
			args = JSON.parse(args);
			if (typeof x.wam[args.module] !== 'undefined') {
				// x.wam[args.module].updatePostingsUnread(9);
				x.wam[args.module].reload();
			}
			x.was.loadActiveMember();
		});

		connection.on('typing', (args) => {
			args = JSON.parse(args);
			if (args.memberid !== x.was.memberId) {
				if (typeof x.was.setMemberTyping !== 'undefined') {
					x.was.setMemberTyping(args.memberid);
				}
				if (args.forumId && typeof x.wam[args.forumId] !== 'undefined' && typeof x.wam[args.forumId].setTyping !== 'undefined') {
					x.wam[args.forumId].setTyping(args.member);
				}
			}
		});

		connection.on('read-posting', (args) => {
			args = JSON.parse(args);
			if (args.memberid === x.was.memberId) {
				console.log('Read Posting...');
				x.was.loadActiveMember();
				if (typeof x.wam[args.module] !== 'undefined') {
					x.wam[args.module].reload();
				}
			}
		});
	
	
		connection.on('login', (args) => {
			args = JSON.parse(args);
			x.was.loadActiveMember();
		});

		connection.on('logout', (args) => {
			args = JSON.parse(args);
			x.was.loadActiveMember();
		});

		connection.on('update', (args) => {
			console.log('Update Member...');
			/* 
			const dregg = new Error('I was called').stack;
			const stack = dregg.split('\n');
			console.log(dregg);
			console.log(stack[0]);
			console.log(stack[2]);
			*/
		});

		connection.on('smilies-update', (args) => {
			x.was.axGet('/Backend/webapp.php?module=System&task=ReloadSessionData', (result) => {
				x.was.setSmilies(result.data.content.smilies);
			});
		});

		connection.on('software-update', (args) => {
			localStorage.setItem('software-update', 1);
			window.location.reload();
		});

		connection.on('ping', (args) => {
			console.log('Ping.....' + args);
			return true;
		});
		
		connection.on('connect', (args) => {
			console.log('Connect...');
			x.wam.reloadForums();
			x.was.loadActiveMember();
		});

		connection.on('disconnect', (args) => {
			console.log('Disconnect...');
		});

	}

	function socketSend(type, args, handleResult = false) {
		args.member = x.was.memberName;
		args.memberid = x.was.memberId;
		// console.log(args);
		try {
			if (handleResult === false) {
				connection.emit(type, JSON.stringify(args));				
			}
			else {
				connection.emit(type, JSON.stringify(args), (response) => {
					// console.log('Response: ' + response);
					handleResult(JSON.parse(response));
				});
			}
		} catch (error) {
			console.log('socket.io error');
		}
	}

	function addDialog(obj) {
		x.wad.init(obj.props.id);
		obj = { tag: obj };
		setDialog(current => [...current, obj]);
	};

	function addHint(obj) {
		obj = { tag: obj };
		setHint(current => [...current, obj]);
	};

	const addModule = (obj) => {
		x.wam.init(obj.props.id);
		x.wam.current = obj.props.id;
		obj = { tag: obj };
		setModule(current => [...current, obj]);
	};

	const addNavigation = (obj) => {
		obj = { tag: obj };
		setNavigation(current => [...current.filter(item => item.tag.props.id !== obj.tag.props.id), obj]);
	};


	function removeDialog(id) {
		delete x.wad[id];
		setDialog(prev => prev.filter(moduleTag => moduleTag.tag.props.id !== id))
	}

	function removeHint(id) {
		delete x.wah[id];
		setHint(prev => prev.filter(hintTag => hintTag.tag.props.id !== id))
	}

	function removeModule(id) {
		x.wam[id].onClose();
		delete x.wam[id];
		delete x.was.postingsUnread[id];
		setModule(prev => prev.filter(moduleTag => moduleTag.tag.props.id !== id))
		// console.log(x.wam);
	}



	function init() {
		// Dialog-Definition
		x.wad.addTag(<DialogOk id="ok" x={x} />);
		x.wad.addTag(<DialogYesNo id="yesno" x={x} />);

		// Modul-Definition
		x.wam.addTag(<Forum id="forum" forumId="forum" x={x} forum={true} title={x.was.application} display="d-none" />);
		x.wam.addTag(<Forum id="admin" forumId="admin" x={x} forum={true} title={'Admin-Forum'} display="d-none" />);
		// x.wam.addTag(<Test id="test" x={x} title="Test" />);
		// x.wam.addTag(<Forum id="forum-admin" x={x} title="Admin-Forum" display="d-none" />);
		x.wam.addTag(<Smilies id="smilies" x={x} title="Smilies" display="d-box" />);
		x.wam.addTag(<Foren id="foren" x={x} title="Foren" display="d-box" />);
		x.wam.addTag(<Topics id="topics" x={x} title="Themen" display="d-box" />);
		x.wam.addTag(<MemberList id="member-list" x={x} active={false} title="Mitgliederliste" display="d-box" />);
		x.wam.addTag(<SystemInfo id="system-info" x={x} title="System-Information" display="d-box" />);
		x.wam.addTag(<HintToMembers id="hint-to-members" x={x} title="Nachricht an alle" display="d-box" />);
		x.wam.addTag(<Sections id="sections" x={x} title="Page Store Rubriken" display="d-box" />);
		x.wam.addTag(<Pages id="pages" x={x} title="Page Store Seiten" display="d-box" />);
		x.wam.addTag(<Settings id="settings" x={x} title="Einstellungen" display="d-box" />);
		x.wam.addTag(<PhpInfo id="php-info" x={x} title="PHP-Info" display="d-box" />);
		x.wam.addTag(<PushSubscriptions id="push-subscriptions" x={x} title="Push-Subscriptions" display="d-box" />);
	}

	function makeContent() {
		// Erzeuge Dialoge
		addDialog(x.wad.tags['ok']);
		addDialog(x.wad.tags['yesno']);
		// addDialog(x.wad.tags['dialog-form']);

		// Erzeuge Module
		if (x.was.isAdmin()) addModule(x.wam.tags['admin']);
		addModule(x.wam.tags['forum']);
	}

	return (
			(props.webAppReady) 
				?
					<div key="content" id="content">
						<Modal id="modal" x={x} />
						{(props.login === false) 
							?
								<>
									<NavigationLeft id="navigation-left" x={x} />
									<NavigationTop id="navigation-top" forum={true} x={x} forumUnread={forumUnread} />
								</>
							:	
								<Login id="login" x={x} formId="login" title="Login" />							
						}
						{dialog.map(({ tag, id }) =>
							<React.Fragment key={"dialog-" + tag.props.id}> {tag}</React.Fragment>
						)}
						<div key="hint" id="hint" className="hint-frame" >
							{hint.map(({ tag, id }) =>
								<React.Fragment key={"hint-" + tag.props.id}> {tag}</React.Fragment>
							)}
						</div>
						{navigation.map(({ tag, id }) =>
							<React.Fragment key={"navigation-" + tag.props.id}> {tag}</React.Fragment>
						)}
						<div key="module" id="module" className="flex-fill overflow-hidden" >
							{module.map(({ tag, id }) =>
								<React.Fragment key={"module-" + tag.props.id}>
									{(tag.props.forum === true) ? React.cloneElement(tag, { updateForum: props.renderForum }) : tag}
								</React.Fragment>
							)}
						</div>
					</div>
			:
					null
	);
}
